// SEO helper — sets document.title, description, canonical, and Open Graph tags.
import { useEffect } from "react";

const SITE_NAME = "Hydration Hub";
const DEFAULT_OG_IMAGE = "https://images.unsplash.com/photo-1523362628745-0c100150b504?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

const setMeta = (name, content) => {
    if (!content) return;
    let tag = document.querySelector(`meta[name="${name}"]`);
    if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", name);
        document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
};

const setOg = (property, content) => {
    if (!content) return;
    let tag = document.querySelector(`meta[property="${property}"]`);
    if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("property", property);
        document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
};

const setCanonical = (url) => {
    if (!url) return;
    let tag = document.querySelector('link[rel="canonical"]');
    if (!tag) {
        tag = document.createElement("link");
        tag.setAttribute("rel", "canonical");
        document.head.appendChild(tag);
    }
    tag.setAttribute("href", url);
};

export const useSeo = ({ title, description, path = "/", ogImage, ogType = "website" }) => {
    useEffect(() => {
        const fullTitle = title ? `${title} — ${SITE_NAME}` : `${SITE_NAME} — Daily Water Intake Calculator (Free)`;
        document.title = fullTitle;
        setMeta("description", description);
        setMeta("viewport", "width=device-width, initial-scale=1");
        setMeta("robots", "index, follow");

        const origin = typeof window !== "undefined" ? window.location.origin : "";
        const url = origin + path;
        setCanonical(url);

        setOg("og:title", title || SITE_NAME);
        setOg("og:description", description || "");
        setOg("og:type", ogType);
        setOg("og:url", url);
        setOg("og:image", ogImage || DEFAULT_OG_IMAGE);
        setOg("og:site_name", SITE_NAME);

        setMeta("twitter:card", "summary_large_image");
        setMeta("twitter:title", title || SITE_NAME);
        setMeta("twitter:description", description || "");
    }, [title, description, path, ogImage, ogType]);
};
